import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  CareerDot,
  CareerPageCompanyName,
  CareerPageDetails,
  CareerPageJobCard,
  CareerPageJobTitle,
  CareerPageLogo,
  CareerPageMetaInfo,
  CareerPagePlaceholderLogo,
} from '../styled'

export function JobListItem({
  company,
  title,
  startDate,
  city,
  country,
  workplaceType,
  logoUrl,
  isHighlighted,
  viewPosition,
  getInitials,
}) {
  function timeSince(startDate) {
    const startTime = new Date(startDate).getTime()
    const currentTime = Date.now()
    const elapsedTime = currentTime - startTime

    const units = [
      { label: 'year', seconds: 365 * 24 * 60 * 60 },
      { label: 'month', seconds: 30 * 24 * 60 * 60 },
      { label: 'week', seconds: 7 * 24 * 60 * 60 },
      { label: 'day', seconds: 24 * 60 * 60 },
      { label: 'hour', seconds: 60 * 60 },
      { label: 'minute', seconds: 60 },
      { label: 'second', seconds: 1 },
    ]

    const { label, seconds } = _.find(
      units,
      ({ seconds }) => elapsedTime / 1000 >= seconds,
    )

    const count = Math.floor(elapsedTime / 1000 / seconds)

    return count === 1 ? `1 ${label} ago` : `${count} ${label}s ago`
  }

  return (
    <CareerPageJobCard isHighlighted={isHighlighted} onClick={viewPosition}>
      {logoUrl ? (
        <CareerPageLogo
          loading="lazy"
          src={logoUrl}
          alt={`${company?.companyName} logo`}
          hasWideAspect={logoUrl?.includes('ext_2-')}
        />
      ) : (
        <CareerPagePlaceholderLogo>
          {getInitials(company?.companyName)}
        </CareerPagePlaceholderLogo>
      )}
      <CareerPageDetails>
        <CareerPageCompanyName>{company?.companyName}</CareerPageCompanyName>
        <CareerPageJobTitle>{title}</CareerPageJobTitle>
        {workplaceType && country && startDate && (
          <CareerPageMetaInfo>
            <span>{city}</span>
            {city && <CareerDot />}
            <span>{country}</span>
            {country && <CareerDot />}
            <time>{timeSince(startDate)}</time>
          </CareerPageMetaInfo>
        )}
      </CareerPageDetails>
    </CareerPageJobCard>
  )
}

JobListItem.propTypes = {
  company: PropTypes.shape({
    companyName: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  workplaceType: PropTypes.string,
  logoUrl: PropTypes.string,
  isHighlighted: PropTypes.bool.isRequired,
  viewPosition: PropTypes.func.isRequired,
  getInitials: PropTypes.func.isRequired,
}
